var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobSwiftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 122,
    viewBox: "0 0 136 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_144_1251",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 136,
    height: 122
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H136V122H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_144_1251)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8845 0.00683594C143.636 40.8341 124.308 85.8582 124.308 85.8582C124.308 85.8582 141.3 105.134 134.433 121.992C134.433 121.992 127.424 110.185 115.672 110.185C104.344 110.185 97.6885 121.992 74.8927 121.992C24.1332 121.992 0.132812 79.3849 0.132812 79.3849C45.8665 109.614 77.0882 88.2055 77.0882 88.2055C56.4866 76.1836 12.6642 18.7119 12.6642 18.7119C50.8232 51.3615 67.318 59.9674 67.318 59.9674C57.4775 51.7885 29.867 11.814 29.867 11.814C51.9549 34.2901 95.8489 65.6587 95.8489 65.6587C108.309 30.9473 83.8845 0.00683594 83.8845 0.00683594Z",
    fill: "#252B33"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobSwiftIcon);
export default __webpack_public_path__ + "static/media/mob-swift-icon.e70f3766a7ae2a31b2cabfe0f66b15c9.svg";
export { ForwardRef as ReactComponent };